type FordVehicleFields = {
  make?: unknown;
  model?: unknown;
  vin?: unknown;
};

type FordAdrEntry = {
  data?: FordVehicleFields & {
    vehicle?: FordVehicleFields;
  };
};

const FALLBACK_DISPLAY_NAME = 'Ford Vehicle';

const asTrimmedString = (value: unknown): string => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
};

/**
 * Resolve the UNITE call-queue primary label for a Ford crash ADR payload.
 * Prefer make + model from VIN decode; fall back to "Ford Vehicle" when
 * decode fields are missing. Never returns a VIN or phone-formatted ID.
 */
export const getFordQueueDisplayName = (
  fordAdr: FordAdrEntry[] | FordAdrEntry | null | undefined,
): string => {
  const entry = Array.isArray(fordAdr) ? fordAdr[0] : fordAdr;
  const data = entry?.data;
  const vehicle = data?.vehicle ?? data;
  const make = asTrimmedString(vehicle?.make);
  const model = asTrimmedString(vehicle?.model);

  if (make && model) {
    return `${make} ${model}`;
  }
  if (make) {
    return make;
  }
  if (model) {
    return model;
  }
  return FALLBACK_DISPLAY_NAME;
};

export default getFordQueueDisplayName;
